
(function () {
  const PC = document.querySelector('.jsPcModal');
  const MOB = document.querySelector('.mobileModal');
  if (!PC && !MOB) return;

  const modals = [PC, MOB].filter(Boolean);
  const triggers = [...document.querySelectorAll('[data-menu-toggle]')];

  const narrow = window.matchMedia('(max-width: 1000px)');

  const pick = () => ((narrow.matches ? MOB : PC) || MOB || PC);
  const opened = () => modals.find((m) => m.classList.contains('active'));

  function placePc() {
    const head = document.querySelector('.site-header');
    const top = head ? Math.max(0, Math.round(head.getBoundingClientRect().bottom)) : 0;
    PC.style.top = top + 'px';
    PC.style.height = 'calc(100% - ' + top + 'px)';
  }

  function open(modal) {
    if (!modal) return;
    if (modal === PC) placePc();
    modal.classList.add('active');
    document.body.classList.add('active', 'mobileModalOpen');
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
  }

  function close() {
    modals.forEach((m) => {
      m.classList.remove('active');

      m.querySelectorAll('.jsWrapChildren.active').forEach((w) => w.classList.remove('active'));
    });
    document.body.classList.remove('active', 'mobileModalOpen');
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
  }

  triggers.forEach((t) =>
    t.addEventListener('click', () => {
      const on = opened();
      if (on) close();
      else open(pick());
    })
  );

  modals.forEach((root) => {
    root.addEventListener('click', (e) => {

      const tab = e.target.closest('.tabHead .tabItem[data-id]');
      if (tab) {
        root.querySelectorAll('.tabHead .tabItem').forEach((x) => x.classList.remove('active'));
        root.querySelectorAll('.tabMain > .tabItem').forEach((x) => x.classList.remove('active'));
        root.querySelectorAll('.jsWrapChildren.active').forEach((w) => w.classList.remove('active'));
        tab.classList.add('active');
        const panel = root.querySelector('#' + CSS.escape(tab.dataset.id));
        if (panel) panel.classList.add('active');
        return;
      }

      const opener = e.target.closest('.jsOpenChildren');
      if (opener) {
        const wrap = opener.closest('.item.jsParentWrap');
        const sub = wrap && wrap.nextElementSibling;
        if (sub && sub.classList.contains('jsWrapChildren')) sub.classList.add('active');
        return;
      }

      if (e.target.closest('.jsBackCatalog')) {
        const sub = e.target.closest('.jsWrapChildren');
        if (sub) sub.classList.remove('active');
        return;
      }

      if (e.target.closest('.close')) close();
    });

    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const hit = e.target.closest('.close, .jsOpenChildren, .jsBackCatalog, .tabHead .tabItem[data-id]');
      if (!hit) return;
      e.preventDefault();
      hit.click();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const on = opened();
    if (!on) return;
    const sub = on.querySelector('.jsWrapChildren.active');
    if (sub) sub.classList.remove('active');
    else close();
  });

  narrow.addEventListener('change', () => {
    if (opened()) close();
  });
})();
